// modules
import React from 'react'
import Link from 'react-router-dom/Link'

const NotFound = () => {
  const handleClick = (e) => {
    e.preventDefault()
    window.history.back()
  }

  return (
    <div className="not-found">
      <h1 className="h1">404</h1>

      <span
        style={{ maxWidth: '50vw', display: 'inline-block' }}
        className="not-found-text">
        Oops! This wasn&apos;t expected... It looks like you&apos;ve reached a
        page that doesn’t exist. For easy navigation, feel free to
        <Link to="/"> return to our Home Page </Link>
        or go <a onClick={handleClick}>Back</a> to the Previous Page. If you
        need immediate assistance, the EmmaCare support team is here to help at
        <a href="mailto: admin@emmacare.com"> admin@emmacare.com</a>.
      </span>

      <img alt="" src={require('src/assets/images/dog_sad.png')} />
    </div>
  )
}

export default NotFound
